var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 143,
    height: 112,
    x: 27,
    rx: 5.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 158,
    height: 102.82,
    rx: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M5.75 0h146.5A5.75 5.75 0 0 1 158 5.75v13.19H0V5.75A5.75 5.75 0 0 1 5.75 0zm.528 7.344v4.197h12.556V7.344H6.278zm23.02 0v4.197h12.556V7.344H29.298zm23.02 0v4.197h12.556V7.344H52.318zm95.897 5.514a3.38 3.38 0 0 0 3.376-3.382 3.38 3.38 0 0 0-3.376-3.383 3.38 3.38 0 0 0-3.376 3.383 3.38 3.38 0 0 0 3.376 3.382z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.6 66.61)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 111,
    x: 27.5,
    y: 0.5,
    stroke: "#64808C",
    rx: 5.75
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.6 76.61)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 101.82,
    x: 0.5,
    y: 0.5,
    stroke: "#64808C",
    rx: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M7.4 58.39h25M7.4 65.39h25M7.4 72.39h25M7.4 79.39h25"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M.5 18.44h157V5.75c0-2.9-2.35-5.25-5.25-5.25H5.75A5.25 5.25 0 0 0 .5 5.75v12.69zm5.278-6.399V6.844h13.556v5.197H5.778zm23.02 0V6.844h13.556v5.197H28.798zm23.02 0V6.844h13.556v5.197H51.818zm96.397 1.317a3.88 3.88 0 0 1-3.876-3.882 3.88 3.88 0 0 1 3.876-3.883 3.88 3.88 0 0 1 3.876 3.883 3.88 3.88 0 0 1-3.876 3.882z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.625,
    cy: 39.91,
    fill: "#FFF",
    stroke: "#64808C",
    rx: 7.412,
    ry: 7.441
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.625,
    cy: 61.556,
    fill: "#87D5FA",
    stroke: "#87D5FA",
    strokeWidth: 1.15,
    rx: 7.412,
    ry: 7.441
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.625,
    cy: 84.556,
    fill: "#FFF",
    stroke: "#64808C",
    rx: 7.412,
    ry: 7.441
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M73.45 35.852h33.693M73.45 57.498h33.693M73.45 80.497h33.693"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M73 44.353h67.386M73.45 65.615h67.386M73.45 88.614h67.386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M7 26h26v26H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.498 41a8.21 8.21 0 0 1-6.996 0C13.905 41.514 12 43.324 12 45.486V48h16v-2.514c0-2.189-1.94-3.972-4.502-4.486zM20 40c2.774 0 5-2.26 5-5s-2.26-5-5-5-5 2.295-5 5.034C15 37.774 17.226 40 20 40z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M40 19v83"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#64808C",
    transform: "translate(204.6 150.61)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.714,
    cy: 19.732,
    fill: "#FFF",
    rx: 19.714,
    ry: 19.732
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.09 22.657l5.086 4.475 12.163-12.333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCreated);
export default __webpack_public_path__ + "static/media/account-created.95b8df3bf5ad78ad8a2c96d2a7b05b4b.svg";
export { ForwardRef as ReactComponent };